import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useVaccinationStore = defineStore({
    id: 'vaccination',
    state: () => ({
        eggDescList: [
            {
                eggIconObject: { componentName: 'naviVaccination', imagName: 'vaccine', imgFormat: 'svg', width: '4.6vw' }
            }
        ],
        vacAdultType: [
            'naviVaccination.naviVaccinationAdultDescP1',
            'naviVaccination.naviVaccinationAdultDescP2',
            'naviVaccination.naviVaccinationAdultDescP3',
            'naviVaccination.naviVaccinationAdultDescP4',
            'naviVaccination.naviVaccinationAdultDescP5',
            'naviVaccination.naviVaccinationAdultDescP6',
            'naviVaccination.naviVaccinationAdultDescP7',
            'naviVaccination.naviVaccinationAdultDescP8',
            'naviVaccination.naviVaccinationAdultDescP9',
            'naviVaccination.naviVaccinationAdultDescP10',
        ],
    }),
    getters: {},
    actions: {
    },
});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useVaccinationStore, import.meta.hot));
}

export { useVaccinationStore };